/* eslint-disable no-undef */
import React from "react";

function ViewPDF(props) {
  return (
    <div
      style={{ display: props.display === true ? "flex" : "none", position: "absolute", top: "40px", right: "40px" }}
    >
      <img src={require("../../../../assets/ViewPDF.png")} />
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="32"
        viewBox="0 0 72 32"
        fill="none"
        style={{ position: "absolute", right: "25px", bottom: "1px" }}
      >
        <g filter="url(#filter0_d_7007_114491)">
          <mask id="path-1-inside-1_7007_114491" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 6C11.7909 6 10 7.79086 10 10V24C10 26.2091 11.7909 28 14 28H65C67.2091 28 69 26.2091 69 24V21.0697L72.1361 17.9337C72.5266 17.5431 72.5266 16.91 72.1361 16.5194L69 13.3834V10C69 7.79086 67.2091 6 65 6H14Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 6C11.7909 6 10 7.79086 10 10V24C10 26.2091 11.7909 28 14 28H65C67.2091 28 69 26.2091 69 24V21.0697L72.1361 17.9337C72.5266 17.5431 72.5266 16.91 72.1361 16.5194L69 13.3834V10C69 7.79086 67.2091 6 65 6H14Z"
            fill="#FCF0ED"
          />
          <path
            d="M69 21.0697L68.2929 20.3626L68 20.6555V21.0697H69ZM72.1361 17.9337L72.8432 18.6408V18.6408L72.1361 17.9337ZM72.1361 16.5194L71.429 17.2266L71.429 17.2266L72.1361 16.5194ZM69 13.3834H68V13.7976L68.2929 14.0905L69 13.3834ZM11 10C11 8.34315 12.3431 7 14 7V5C11.2386 5 9 7.23858 9 10H11ZM11 24V10H9V24H11ZM14 27C12.3431 27 11 25.6569 11 24H9C9 26.7614 11.2386 29 14 29V27ZM65 27H14V29H65V27ZM68 24C68 25.6569 66.6569 27 65 27V29C67.7614 29 70 26.7614 70 24H68ZM68 21.0697V24H70V21.0697H68ZM71.429 17.2266L68.2929 20.3626L69.7071 21.7768L72.8432 18.6408L71.429 17.2266ZM71.429 17.2266V17.2266L72.8432 18.6408C73.6242 17.8597 73.6242 16.5934 72.8432 15.8123L71.429 17.2266ZM68.2929 14.0905L71.429 17.2266L72.8432 15.8123L69.7071 12.6763L68.2929 14.0905ZM68 10V13.3834H70V10H68ZM65 7C66.6569 7 68 8.34315 68 10H70C70 7.23858 67.7614 5 65 5V7ZM14 7H65V5H14V7Z"
            fill="#A82C0C"
            mask="url(#path-1-inside-1_7007_114491)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7007_114491"
            x="0"
            y="0"
            width="82.4287"
            height="42"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7007_114491" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7007_114491" result="shape" />
          </filter>
        </defs>
        <text
          x="55%"
          y="63%"
          text-anchor="middle"
          fill="var(--primary-Red, #A82C0C)"
          font-family="Poppins"
          font-size="11px"
          font-style="normal"
          font-weight="400"
          line-height="16px"
        >
          View PDF
        </text>
      </svg> */}
    </div>
  );
}

export default ViewPDF;
